import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-setting-sharing-dialog",
  "use": "icon-setting-sharing-dialog-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-setting-sharing-dialog\">\n<path d=\"M14.9668 8.57032L9.4668 3.32031V6.32031C4.20336 6.32031 2.9668 10.0944 2.9668 13.8203C4.48586 11.8753 5.8293 10.8203 9.4668 10.8203V13.8203L14.9668 8.57032Z\" stroke=\"#98A1B3\" stroke-width=\"1.00189\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol